import * as React from 'react';
import { SVGProps } from 'react';

const IconMLSPSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0h6v2h-.985l.865 4H13v2H3V6h2.15l.842-4H5V0Zm2.826 3-.632 3h1.64l-.65-3h-.358Z"
    />
    <path d="M0 11.825v-2l.773-.508a3 3 0 0 1 2.395-.126l2.366.888a1 1 0 0 0 .799-.042l1.39-.695a3 3 0 0 1 2.523-.075l1.708.732a1 1 0 0 0 .908-.062l.682-.409A3 3 0 0 1 16 9.243v2.196l-.465-.232a1 1 0 0 0-.962.036l-.682.41A3 3 0 0 1 12 12.06V14h-2v-2.662l-.541-.232a1 1 0 0 0-.841.024l-1.39.695A2.999 2.999 0 0 1 6 12.14V14H4v-2.36l-1.535-.576a1 1 0 0 0-.798.042L0 11.826Z" />
  </svg>
);
export default IconMLSPSizeS;
